/*       */

import { gql } from '@apollo/client';
import entitiesListShortCommonQuery from 'graphql/entities/common/entitiesListShortCommonQuery';

export default gql`
    query personListShortQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "person", filterBy: $filterBy, excludeBy: $excludeBy)
        records: people(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListShortCommonQuery}
        }
    }
`;
